import { createAction } from 'redux-actions';
export const RELOAD_SEARCH_AND_FILTER_DATA = 'RELOAD_SEARCH_AND_FILTER_DATA';
export const reloadSearchAndFilterData = createAction(RELOAD_SEARCH_AND_FILTER_DATA, filterKey => ({
  filterKey
}));